import React, { useEffect } from 'react'
import injectSheet from 'react-jss'
import Section from '../../../shared/section/section'
import Segment from '../../../shared/segment/segment'
import Segments from '../../../shared/segments/segments'
import Description from '../../../shared/description/description'
import FormLabel from 'pobble-components/dist/form-elements/form-label'
import styles from './oauth.styles'
import Providers from './providers/providers.container'
import ConnectProvider from './connect-provider/connect-provider.container'

const Oauth = ({ classes, onMount }) => {
  useEffect(
    () => {
      onMount()
    },
    [onMount]
  )
  return (
    <Section title="Single sign-on">
      <Segments>
        <Segment className={classes.segment}>
          <FormLabel className={classes.label}>Connected providers:</FormLabel>
          <Providers />
        </Segment>
        <Segment className={classes.segment}>
          <FormLabel className={classes.label}>Connect provider:</FormLabel>
          <ConnectProvider />
        </Segment>
        <Segment>
          <Description>
            Single Sign-On (SSO) lets you access Pobble using your existing
            identity provider instead of a separate username and password. If
            you choose SSO, authentication is managed by that provider, where
            you can also enable Multi-Factor Authentication (MFA) for added
            security.
          </Description>
        </Segment>
      </Segments>
    </Section>
  )
}

export default injectSheet(styles)(Oauth)
